module.exports = __webpack_public_path__ + "img/team-member-08.23d3ad31.jpg";